import { useSelector } from 'react-redux';

import {
    AGREEMENT_CONTRACT_ERROR,
    AGREEMENT_GENERAL_ERROR,
    AGREEMENTS_ERROR,
    COLLATERAL_AGREEMENT_ERROR,
    COLLATERAL_GENERAL_ERROR,
    COLLATERAL_TOKENS_ERROR,
    COLLATERAL_WALLET_ERROR,
    TOKENS_ERROR,
    USER_BORROWS_ERROR,
    USER_VAULTS_ERROR,
    USERS_SUPPLIES_BALANCE_ERROR,
    USERS_SUPPLIES_ERROR,
    USERS_SUPPLIES_PENDING_REWARDS_ERROR,
    USERS_VAULTS_CONTRACT_NOT_AVAILABLE_ERROR,
    USERS_VAULTS_PENDING_REWARDS_ERROR,
    VAULT_ERROR,
} from '../store/errors/constants';

import { Store } from '@/shared/store';

/**
 *  Common wrapper for error hooks
 */
export const useHasErrors = (errorKeys: (keyof Store['errors'])[]): boolean => {
    return useSelector((state: Store) => {
        return errorKeys.some((key) => {
            const errorArray = state.errors[key];
            return (errorArray?.length ?? 0) > 0;
        });
    });
};

/**
 *  Hooks return boolean
 */
export const useHasAgreementError = () =>
    useHasErrors([
        AGREEMENTS_ERROR,
        TOKENS_ERROR,
        AGREEMENT_GENERAL_ERROR,
        // AGREEMENT_ROLE_ERROR,
    ]);

export const useHasContractError = () =>
    useHasErrors([
        AGREEMENT_CONTRACT_ERROR,
        //TOKEN_PRICE_ERROR,
    ]);

export const useHasBorrowError = () => useHasErrors([USER_BORROWS_ERROR]);

export const useHasCollateralError = () =>
    useHasErrors([
        COLLATERAL_AGREEMENT_ERROR,
        COLLATERAL_WALLET_ERROR,
        COLLATERAL_TOKENS_ERROR,
        COLLATERAL_GENERAL_ERROR,
    ]);

export const useHasSupplyError = () =>
    useHasErrors([
        USERS_SUPPLIES_ERROR,
        USERS_SUPPLIES_BALANCE_ERROR,
        USERS_SUPPLIES_PENDING_REWARDS_ERROR,
    ]);

export const useHasVaultsError = () => useHasErrors([VAULT_ERROR, TOKENS_ERROR]);

export const useHasUserVaultsError = () =>
    useHasErrors([
        USER_VAULTS_ERROR,
        USERS_VAULTS_CONTRACT_NOT_AVAILABLE_ERROR,
        USERS_VAULTS_PENDING_REWARDS_ERROR,
    ]);

/**
 *  Hooks return set of errors
 */

export const useContractErrorState = () => {
    return useSelector((state: Store) => ({
        agreementContractError: state.errors.AGREEMENT_CONTRACT_ERROR,
    }));
};
